import { Card } from '@svs/ui/react/card';
import type { PropsWithChildren, ReactNode } from 'react';

type AsideSideNavProps = PropsWithChildren;

/**
 * Aside element.
 *
 * @param root0 input object
 * @param root0.children children to pass down
 * @returns aside element with correct styling for the aside sidenav.
 */
export default function AsideSideNav({ children }: AsideSideNavProps): ReactNode {
  return (
    <aside className="sticky top-25 mb-6 hidden h-fit pb-19 lg:col-span-5 lg:block xl:top-40">
      <Card className="bg-surface-elevated" hasPadding={false}>
        {children}
      </Card>
    </aside>
  );
}
